import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-accept-cookies',
  templateUrl: './accept-cookies.component.html',
  styleUrls: ['./accept-cookies.component.scss']
})
export class AcceptCookiesComponent implements OnInit {

  acceptCookiesStart;
  show = false;

  constructor(
    private cookies: CookieService
  ) { }

  ngOnInit() {
    if (this.cookies.get('acceptCookiesStart') == '1') {
      this.show = true;
    }
  }

  acceptCookie() {
    this.cookies.set('acceptCookiesStart', '1');
    this.show = true;
  }

}
